import { render, staticRenderFns } from "./GamesPlayed.vue?vue&type=template&id=edff8ca4&scoped=true&"
import script from "./GamesPlayed.vue?vue&type=script&lang=js&"
export * from "./GamesPlayed.vue?vue&type=script&lang=js&"
import style0 from "./GamesPlayed.vue?vue&type=style&index=0&id=edff8ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edff8ca4",
  null
  
)

export default component.exports